import clsx from "clsx";
import { FC } from "react";

import { FramerTooltip } from "../tooltips";

interface IMapTooltipEllipsisValueProps {
  text: string;
  className?: string;
}

/** Truncated detail value with full text in FramerTooltip (portal, works inside Leaflet popup). */
export const MapTooltipEllipsisValue: FC<IMapTooltipEllipsisValueProps> = ({
  text,
  className,
}) => (
  <FramerTooltip content={text}>
    <span className={clsx("detail-row__value", "truncate-text", className)}>
      {text}
    </span>
  </FramerTooltip>
);
